import { Controller } from "@hotwired/stimulus";
import SimpleBar from "simplebar";
import "simplebar/dist/simplebar.css";

export default class extends Controller {
  static targets = ["content"];

  //読み込み時
  initialize() {
    this.contentTargets.forEach((element) => {
      new SimpleBar(element, { autoHide: false });
    });
  }
}
